import React, { useContext, useState, useRef } from "react";
import img from "../../Assets/Image_lc/login l2c.webp";
import MyContext from "../../MyContext";
import { useLocation } from "react-router-dom";
import { useEffect } from "react";
import ShopBanner from "../../../API/API_SERVISES/Shopbanner";

const LoginPanel_Lc = (props) => {
  const {
    signupshow1,
    LoginAccount,
    LoginWithOTP,
    forgotPassword,
    inputValuesForLogin,
    handleInputChangeLogin,
    close,
    SendOtp2,
    // isDisabled,
    // secondsLeft,
    // visibleResendOTP,

  } = props;

  const { imageBaseUrl, shopBanner, signUpOtp, apiBannerData, setLoginPanel } = useContext(MyContext);

  const [showPassword, setShowPassword] = useState(false);
  const [loginWithOTP, setLoginWithOTP] = useState(false);
  const inputRefs = [useRef(), useRef(), useRef(), useRef()];
  const [otp, setOtp] = useState(["", "", "", ""]);

  const togglePasswordVisibility = (val) => {
    setShowPassword(!showPassword);
  };

  const useQuery = () => {
    return new URLSearchParams(useLocation().search);
  }

  const location = useLocation();
  const query = useQuery();
  const productId = query.get('productId');

  const ImageId =
    apiBannerData &&
    apiBannerData
      // .filter((item) => item.showInCategoryGroup == productId)
      .map((image) => image.bannerImageId);
  console.log(ImageId);


  const handleInputChange = (index, value) => {
    const newOTP = [...otp];
    newOTP[index] = value;
    setOtp(newOTP);
    if (value !== "") {
      const nextIndex = index < 3 ? index + 1 : index;
      inputRefs[nextIndex].current.focus();
    }
  };

  const handleKeyDown = (index, e) => {
    if (inputRefs[index].current.value !== "") return;

    // console.log(e.key);
    if (e.key == "Backspace") {
      const prevIndex = index <= 0 ? 0 : index - 1;
      inputRefs[prevIndex].current.focus();
    }
  };

  const isAllFieldsFilled = otp.every((value) => value !== "");

  return (

    <div className="form-container-login-theme3 form-loginWidth-Lc">

      {ImageId.length > 0 && (
        <img style={{
          height: ImageId.length === 0 ? "0" : "max-content",
        }}
          className="Login-Img_Lc" src={ImageId.length > 0 ? `${imageBaseUrl}${ImageId[0]}` : ""}
          alt="" />
      )}

      <i onClick={close} style={{ cursor: "pointer" }} className="fa-solid fa-xmark modal-cross"></i>
      <div className="SignIn-Padding-Lc">
        <p style={{ marginBottom: "20px", border: "none" }} className="title sign-a-acc">
          Sign In
        </p>
        <div className="form-modal">
          {loginWithOTP ? (
            <>
              <div className="login-panel-lc-send-otp-email-container ">
                <input
                  type="email"
                  className="input-modal"
                  placeholder="Email/Mobile No"
                  onChange={handleInputChangeLogin}
                  value={inputValuesForLogin.name_email}
                  name="name_email"
                />

                <button
                  onClick={SendOtp2}
                  className="SendOTPButton"
                
                  style={{ borderRadius: "15px" }}
                >
                  Send OTP
                </button>
              </div>
              <div className="flex-whatsapp-otp">
              <div className="whatsapp-update">Get updates on Whatsapp</div>
              <div className="whatsaap-icon-otp"><i class="fa-brands fa-whatsapp"></i></div>
              </div>
              <div className="inputContainer">
                <input
                  ref={inputRefs[0]}
                  required="required"
                  maxLength="1"
                  type="text"
                  name="otp"
                  value={otp[0]}
                  className="otp-input"
                  id="otp-input1"
                  onChange={(e) => handleInputChange(0, e.target.value)}
                  onKeyDown={(e) => handleKeyDown(0, e)}
                />
                <input
                  ref={inputRefs[1]}
                  required="required"
                  maxLength="1"
                  type="text"
                  name="otp"
                  value={otp[1]}
                  className="otp-input"
                  id="otp-input2"
                  onChange={(e) => handleInputChange(1, e.target.value)}
                  onKeyDown={(e) => handleKeyDown(1, e)}
                />
                <input
                  ref={inputRefs[2]}
                  required="required"
                  maxLength="1"
                  type="text"
                  name="otp"
                  value={otp[2]}
                  className="otp-input"
                  id="otp-input3"
                  onChange={(e) => handleInputChange(2, e.target.value)}
                  onKeyDown={(e) => handleKeyDown(2, e)}
                />
                <input
                  ref={inputRefs[3]}
                  required="required"
                  maxLength="1"
                  type="text"
                  name="otp"
                  value={otp[3]}
                  className="otp-input"
                  id="otp-input4"
                  onChange={(e) => handleInputChange(3, e.target.value)}
                  onKeyDown={(e) => handleKeyDown(3, e)}
                />
              </div>
            </>
          ) : (
            <>
              <input
                type="email"
                className="input-modal"
                placeholder="Email/Mobile No"
                onChange={handleInputChangeLogin}
                value={inputValuesForLogin.name_email}
                name="name_email"
              />

              <div style={{ position: "relative" }}>
                <input
                  type={showPassword ? "text" : "password"}
                  className="input-modal"
                  onChange={handleInputChangeLogin}
                  name="password"
                  value={inputValuesForLogin.password}
                  placeholder="Password"
                  onKeyDown={(e) => {
                    if (e.key === "Enter") {
                      LoginAccount();
                    }
                  }}
                />
                <p className="page-link">
                  <span className="page-link-label" onClick={forgotPassword}>
                    Forgot Password?
                  </span>
                  <div
                    className="input-image position-icon-pw"
                    onClick={() => togglePasswordVisibility("password")}
                  >
                    {showPassword ? (
                      <i className="fa-solid fa-eye-slash"></i>
                    ) : (
                      <i className="fa-solid fa-eye"></i>
                    )}
                  </div>
                </p>
              </div>
            </>
          )}

          {!loginWithOTP ? (
            <div
              onClick={LoginAccount}
              style={{ textDecoration: "none", textAlign: "center" }}
              className="form-btn"
            >
              Log in
            </div>
          ) : (
            <div
              onClick={() => LoginWithOTP(otp)}
              style={{
                textDecoration: "none",
                textAlign: "center",
                background: isAllFieldsFilled ? "" : "#00bac6",
              }}
              className="form-btn"
            >
              Log in otp
            </div>
          )}

            {/* {visibleResendOTP && (
            <p
              onClick={SendOtp2}
              style={{
                color: isDisabled ? "#947bdd" : "rgba(156, 163, 175, 1)",
              }}
              className="resendNote"
              disabled={isDisabled}
            >
              {isDisabled ? (
                `Resend OTP after ${secondsLeft} sec`
              ) : (
                <span>
                  Haven't received the OTP ?
                  <button className="resendBtn">Resend OTP</button>
                </span>
              )}
            </p>
          )} */}


        </div>
        <div className="sign-up-label">
          New Member?
          <span className="sign-up-link" onClick={signupshow1}>
            Create An Account
          </span>
        </div>

        {/* {isLoginWithOtpEnable && */}
        {!loginWithOTP ? (
          <div className="sign-up-label" style={{ marginTop: "5px" }}>
            <span
              className="sign-up-link"
              onClick={() => setLoginWithOTP(true)}
              style={{ cursor: "pointer" }}
            >
              Login With OTP
            </span>
          </div>
        ) : (
          <div className="sign-up-label" style={{ marginTop: "5px" }}>
            <span
              className="sign-up-link"
              onClick={() => setLoginWithOTP(false)}
              style={{ cursor: "pointer" }}
            >
              Login With Password
            </span>
          </div>
        )}
        {/* // } */}

        <div className="buttons-container">
          {/* Third-party login buttons can go here */}
        </div>
      </div>
    </div>
  );
};

export default LoginPanel_Lc;
